<button mat-icon-button class="clear-button" (click)="close()" data-cy="forms-builder-creation-close-button"><i class="material-icons">clear</i></button>
<div class="main-container" *ngIf="mode == 'create'" data-cy="forms-builder-creation-container">

  <h4 data-cy="forms-builder-creation-title">Create a form</h4>
  <p *ngIf="!subMode" data-cy="forms-builder-creation-intro">Would you like to create a new form or duplicate an existing form?</p>
  <p *ngIf="subMode == 'duplicate'" data-cy="forms-builder-creation-duplicate-intro">Search for a form to duplicate.</p>
  <p *ngIf="subMode == 'create'" data-cy="forms-builder-creation-create-intro">Enter a name for the new form.</p>

  <button mat-raised-button color="primary" class="menu-button" *ngIf="!subMode" (click)="subMode='create'" data-cy="forms-builder-creation-new-button">Create a new form</button>
  <button mat-raised-button color="primary" class="menu-button" *ngIf="!subMode" (click)="initDuplicateMode()" data-cy="forms-builder-creation-duplicate-button">Duplicate a form</button>

  <div *ngIf="subMode == 'duplicate'" data-cy="forms-builder-creation-duplicate-container">

    <div class="form-search-container" data-cy="forms-builder-creation-search-container">
      <div data-cy="forms-builder-creation-search-input-container">
        <input class="form-search-input" type="text" placeholder="Search for form by name"
               (input)="searchForForm($event.target.value)" data-cy="forms-builder-creation-search-input" />
      </div>
      <div class="form-search-results" data-cy="forms-builder-creation-search-results">
        <div class="search-spinner-holder" *ngIf="isSearchingForForms" data-cy="forms-builder-creation-search-spinner">
          <mat-spinner [diameter]="20" data-cy="forms-builder-creation-spinner"></mat-spinner>
        </div>
        <div *ngIf="!isSearchingForForms" data-cy="forms-builder-creation-results-content">
          <div class="search-message" *ngIf="!formSearchResults" data-cy="forms-builder-creation-empty-message">
          </div>
          <div class="search-message" *ngIf="formSearchResults && !formSearchResults.length" data-cy="forms-builder-creation-no-results">
            No forms found
          </div>
          <div class="form-preview" (click)="selectCfgForm(formPreview)" [class.selected]="selectedFormId == formPreview.DFormId"
               *ngFor="let formPreview of formSearchResults; let i = index" data-cy="forms-builder-creation-form-preview-{{i}}">
            {{ formPreview.DFormName }}
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="selectedFormPreview" class="form-input-container" data-cy="forms-builder-creation-new-name-container">

      <div data-cy="forms-builder-creation-name-input-container">
        <input class="new-name-input" type="text" placeholder="Enter a new name" [(ngModel)]="newFormName" data-cy="forms-builder-creation-name-input" />
      </div>

      <button mat-raised-button color="primary" [disabled]="!newFormName" (click)="submitDuplicateForm(selectedFormPreview)" data-cy="forms-builder-creation-duplicate-submit">Duplicate form</button>

    </div>

  </div>

  <div *ngIf="subMode == 'create'" data-cy="forms-builder-creation-create-container">
    <div class="create-input-container" data-cy="forms-builder-creation-create-input-container">
      <div data-cy="forms-builder-creation-create-name-container">
        <input class="new-name-input" type="text" placeholder="Enter a new name" [(ngModel)]="newFormName" data-cy="forms-builder-creation-create-name-input" />
      </div>
      <button mat-raised-button color="primary" (click)="submitNewForm()" [disabled]="!newFormName" data-cy="forms-builder-creation-create-submit">Create form</button>
    </div>
  </div>

</div>

<div class="main-container" *ngIf="mode == 'edit'" data-cy="forms-builder-edit-container">

  <h4 data-cy="forms-builder-edit-title">Edit a form</h4>
  <p *ngIf="!subMode" data-cy="forms-builder-edit-intro">Would you like to create a new version, copy an existing version, edit an existing version or delete the form?</p>
  <p *ngIf="subMode == 'copy'" data-cy="forms-builder-edit-copy-intro">Select the version you want to copy.</p>
  <p *ngIf="subMode == 'edit'" data-cy="forms-builder-edit-version-intro">Select the version you want to edit.</p>

  <button mat-raised-button color="primary" class="menu-button" *ngIf="!subMode" (click)="submitNewVersion()" data-cy="forms-builder-edit-new-version">Create a new version</button>
  <button mat-raised-button color="primary" class="menu-button" *ngIf="!subMode" [disabled]="!existingVersions.length" (click)="subMode = 'copy'" data-cy="forms-builder-edit-copy-version">Copy a version</button>
  <button mat-raised-button color="primary" class="menu-button" *ngIf="!subMode" [disabled]="!existingVersions.length" (click)="subMode = 'edit'" data-cy="forms-builder-edit-version">Edit a version</button>
  <button mat-raised-button color="warn" class="menu-button" *ngIf="!subMode" (click)="deleteForm()" data-cy="forms-builder-edit-delete">Delete this form</button>

  <div *ngIf="subMode == 'copy' || subMode == 'edit'" data-cy="forms-builder-edit-version-container">
    <div class="form-search-results" data-cy="forms-builder-edit-versions-list">
      <div data-cy="forms-builder-edit-versions-content">
        <div class="form-preview" (click)="selectCfgVersion(version)"
             *ngFor="let version of existingVersions; let i = index" data-cy="forms-builder-edit-version-preview-{{i}}">
          {{ version.Version }}
        </div>
      </div>
    </div>
  </div>

</div>
